<script setup lang="ts">
  import { computed } from 'vue'

  const props = withDefaults(
    defineProps<{
      prefix?: string
      name: string | undefined
      size?: string
    }>(),
    {
      prefix: 'icon',
      size: '24',
    }
  )

  const symbolId = computed(() => `#${props.prefix}-${props.name}`)
</script>

<template>
  <svg class="icon" aria-hidden="true" :width="size" :height="size">
    <use :href="symbolId" />
  </svg>
</template>
